import {
  isTokenSuspiciousCheck,
  suspiciousCheckData,
} from '../../Wallets/labels';
import Tooltip from 'modules/shared-components/tooltip';
import {
  formatNumberWithSuffix,
  formatWithoutDecimals,
} from 'utils/FormatNumber';
import { PerformanceStyle } from '../../../../components/alerts/performanceStyle';
import { ColumnsProps } from '../columns';
import { hotTokenDataMapping } from '../hotTokenDataMapping';
import { useMemo } from 'react';

export default function NetFlowColumn({ data, tokenStats }: ColumnsProps) {
  const mappedStats = useMemo(
    () => hotTokenDataMapping(tokenStats, data),
    [tokenStats, data]
  );

  const {
    totalBuy,
    totalBuyTop,
    totalSells,
    totalSellsTop,
    netInflow,
    netInflowTop,
    buyVolume,
    buyVolumeTop,
    sellVolume,
    sellVolumeTop,
  } = mappedStats;

  return (
    <div
      className={
        isTokenSuspiciousCheck(suspiciousCheckData(tokenStats, data))
          ? 'xxs:text-dex-white-secondary'
          : ''
      }
    >
      {netInflow ? (
        <Tooltip
          text={
            <div className="space-y-1">
              <div className="text-xs xxs:flex xxs:space-x-1 items-center">
                <div>Buy Volume:</div>
                <PerformanceStyle
                  noPnl={true}
                  className="text-xs font-bold text-green-500"
                  formatFn={formatNumberWithSuffix}
                  pnl={buyVolumeTop.toString()}
                />
                <div>/</div>
                <PerformanceStyle
                  noPnl={true}
                  className="text-xs"
                  formatFn={formatNumberWithSuffix}
                  pnl={buyVolume.toString()}
                />
              </div>

              <div className="text-xs xxs:flex xxs:space-x-1 items-center">
                <div>Sell Volume:</div>
                <PerformanceStyle
                  noPnl={true}
                  className="text-xs font-bold text-red-500"
                  formatFn={formatNumberWithSuffix}
                  pnl={sellVolumeTop.toString()}
                />
                <div>/</div>
                <PerformanceStyle
                  className="text-xs"
                  noPnl={true}
                  formatFn={formatNumberWithSuffix}
                  pnl={sellVolume.toString()}
                />
              </div>

              <div className="text-xs xxs:flex xxs:space-x-1 items-center">
                <div>Buy Wallets:</div>
                <PerformanceStyle
                  noPnl={true}
                  noAsset={true}
                  className="text-xs font-bold"
                  formatFn={formatWithoutDecimals}
                  pnl={totalBuyTop.toString()}
                />
                <div>/</div>
                <PerformanceStyle
                  noPnl={true}
                  noAsset={true}
                  className="text-xs"
                  formatFn={formatWithoutDecimals}
                  pnl={totalBuy.toString()}
                />
              </div>

              <div className="text-xs xxs:flex xxs:space-x-1 items-center">
                <div>Sell Wallets:</div>
                <PerformanceStyle
                  noPnl={true}
                  noAsset={true}
                  className="text-xs font-bold"
                  formatFn={formatWithoutDecimals}
                  pnl={totalSellsTop.toString()}
                />
                <div>/</div>
                <PerformanceStyle
                  noPnl={true}
                  noAsset={true}
                  className="text-xs"
                  formatFn={formatWithoutDecimals}
                  pnl={totalSells.toString()}
                />
              </div>
            </div>
          }
        >
          <div className="flex items-center space-x-1">
            <PerformanceStyle pnl={netInflowTop.toString()} />
            <div>/</div>
            <PerformanceStyle
              pnl={netInflow.toString()}
              className="xxs:text-[10px]"
            />
          </div>
        </Tooltip>
      ) : (
        <div className="text-xs">--</div>
      )}
    </div>
  );
}
